export default __webpack_public_path__ + "static/media/newPreviousImg.6e3aba45.svg";